import { Modal } from "@breuni-ui/modal";
import { safeDefine } from "@breuni-ui/safe-define";

export class KombiModulModal extends Modal {
  public connectedCallback(): void {
    super.connectedCallback();
    this.querySelectorAll("img").forEach((img) => {
      img.addEventListener(
        "load",
        () => {
          this.refreshBody();
        },
        { once: true },
      );
    });
  }
}

safeDefine("reco-kombi-modul-modal", KombiModulModal);
